@if (passwordValidationResponse?.issues?.length) {
<div class="text-danger bg-gray-lightest p-3">
    <span class="align-middle">{{passwordValidationResponse?.message}}</span>
    <ul>
        @for (item of passwordValidationResponse?.issues; track $index) {
        <li>{{item}}</li>
        }
    </ul>
</div>
}